// @generated by TypeGen from LogbookApi/TripApi.swift - DO NOT EDIT

import type { IAppResponse } from "../LogbookApp/Routes"
import type { ITripCreateResponse } from "../LogbookApp/TripApi"
import { IShipUserLevel } from "../LogbookModel/ShipUser"
import type { ITripResponse, ITripsResponse } from "../LogbookModel/Trip"
import { assertTarget } from "./ApiRuntime"
import type { ApiArgs, ApiClient, ApiTarget, ApiUser } from "./ApiRuntime"

export interface ITripUpdateRequest {
  completed?: boolean;
  data?: string;
  started?: boolean;
  timezone?: number;
  title?: string;
}

export interface TripApiEndpoints {
  "GET /api/ship/trip": {
    params: {};
    query: {};
    request: never;
    response: ITripCreateResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/cruises/:cruiseId/trips": {
    params: { shipId: number; cruiseId: number };
    query: {};
    request: never;
    response: ITripsResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "GET /api/ships/:shipId/trips/:tripId": {
    params: { shipId: number; tripId: number };
    query: {};
    request: never;
    response: ITripResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "POST /api/ship/trip": {
    params: {};
    query: {};
    request: never;
    response: ITripCreateResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/trips/:tripId": {
    params: { shipId: number; tripId: number };
    query: {};
    request: ITripUpdateRequest;
    response: ITripResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
  "PUT /api/ships/:shipId/trips/:tripId/calculate": {
    params: { shipId: number; tripId: number };
    query: {};
    request: never;
    response: IAppResponse;
    targets: ApiTarget[];
    permission: { ship: IShipUserLevel };
  };
}

export const tripApiEndpoints = {
  "GET /api/ship/trip": { targets: ["app"], permission: { ship: IShipUserLevel.viewCurrent } },
  "GET /api/ships/:shipId/cruises/:cruiseId/trips": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "GET /api/ships/:shipId/trips/:tripId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.viewAll } },
  "POST /api/ship/trip": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/trips/:tripId": { targets: ["app", "server"], permission: { ship: IShipUserLevel.editCurrent } },
  "PUT /api/ships/:shipId/trips/:tripId/calculate": { targets: ["app"], permission: { ship: IShipUserLevel.editCurrent } },
} as const;

export class TripApi {
  constructor(private client: ApiClient) {}

  trips = {
    canCreate: (a: ApiArgs<TripApiEndpoints, "GET /api/ship/trip">) => ({
      call: (): Promise<ITripCreateResponse> => {
        assertTarget(this.client, "GET /api/ship/trip", tripApiEndpoints["GET /api/ship/trip"].targets);
        return this.client.call<ITripCreateResponse>("GET /api/ship/trip", a);
      },
      url: (): string => this.client.url("GET /api/ship/trip", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.viewCurrent,
    }),
    list: (a: ApiArgs<TripApiEndpoints, "GET /api/ships/:shipId/cruises/:cruiseId/trips">) => ({
      call: (): Promise<ITripsResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/cruises/:cruiseId/trips", tripApiEndpoints["GET /api/ships/:shipId/cruises/:cruiseId/trips"].targets);
        return this.client.call<ITripsResponse>("GET /api/ships/:shipId/cruises/:cruiseId/trips", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/cruises/:cruiseId/trips", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    get: (a: ApiArgs<TripApiEndpoints, "GET /api/ships/:shipId/trips/:tripId">) => ({
      call: (): Promise<ITripResponse> => {
        assertTarget(this.client, "GET /api/ships/:shipId/trips/:tripId", tripApiEndpoints["GET /api/ships/:shipId/trips/:tripId"].targets);
        return this.client.call<ITripResponse>("GET /api/ships/:shipId/trips/:tripId", a);
      },
      url: (): string => this.client.url("GET /api/ships/:shipId/trips/:tripId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.viewAll,
    }),
    create: (a: ApiArgs<TripApiEndpoints, "POST /api/ship/trip">) => ({
      call: (): Promise<ITripCreateResponse> => {
        assertTarget(this.client, "POST /api/ship/trip", tripApiEndpoints["POST /api/ship/trip"].targets);
        return this.client.call<ITripCreateResponse>("POST /api/ship/trip", a);
      },
      url: (): string => this.client.url("POST /api/ship/trip", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel() ?? -1) >= IShipUserLevel.editCurrent,
    }),
    update: (a: ApiArgs<TripApiEndpoints, "PUT /api/ships/:shipId/trips/:tripId">) => ({
      call: (): Promise<ITripResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/trips/:tripId", tripApiEndpoints["PUT /api/ships/:shipId/trips/:tripId"].targets);
        return this.client.call<ITripResponse>("PUT /api/ships/:shipId/trips/:tripId", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/trips/:tripId", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
    calculate: (a: ApiArgs<TripApiEndpoints, "PUT /api/ships/:shipId/trips/:tripId/calculate">) => ({
      call: (): Promise<IAppResponse> => {
        assertTarget(this.client, "PUT /api/ships/:shipId/trips/:tripId/calculate", tripApiEndpoints["PUT /api/ships/:shipId/trips/:tripId/calculate"].targets);
        return this.client.call<IAppResponse>("PUT /api/ships/:shipId/trips/:tripId/calculate", a);
      },
      url: (): string => this.client.url("PUT /api/ships/:shipId/trips/:tripId/calculate", a),
      available: (user?: ApiUser): boolean => user != null && (user.shipLevel(a.params.shipId) ?? -1) >= IShipUserLevel.editCurrent,
    }),
  };
}
